import { render, staticRenderFns } from "./widgetContainer.vue?vue&type=template&id=8284b9d4"
import script from "./widgetContainer.vue?vue&type=script&lang=js"
export * from "./widgetContainer.vue?vue&type=script&lang=js"
import style0 from "./widgetContainer.vue?vue&type=style&index=0&id=8284b9d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports